// 文書サイズの FBO を使い回すプール。グループ / クリッピングの入れ子で必要になる。
import { createFramebuffer, deleteFramebuffer, type Framebuffer } from './texture'

export class FboPool {
  private free: Framebuffer[] = []
  private all: Framebuffer[] = []
  private size = { w: 0, h: 0 }

  constructor(private gl: WebGL2RenderingContext) {}

  /** サイズが変わったら全部捨てる */
  setSize(w: number, h: number): void {
    if (this.size.w === w && this.size.h === h) return
    this.disposeAll()
    this.size = { w, h }
  }

  acquire(): Framebuffer {
    const f = this.free.pop()
    if (f) return f
    const n = createFramebuffer(this.gl, this.size.w, this.size.h)
    this.all.push(n)
    return n
  }

  release(f: Framebuffer): void {
    // 破棄済み (サイズ変更でプールごと捨てられた) FBO は戻さない。
    // 戻すと次の acquire() が使えない FBO を返す
    if (!this.all.includes(f)) return
    this.free.push(f)
  }

  get count(): number {
    return this.all.length
  }

  disposeAll(): void {
    for (const f of this.all) deleteFramebuffer(this.gl, f)
    this.all = []
    this.free = []
  }
}
